import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  Button,
} from '@mui/material'
import { useGetLogEntries } from '@/service-library/hooks/log-entries'
import DocumentLogEntry from './DocumentLogEntry'
import SectionAccordion from './SectionAccordion'

type DocumentLogEntriesProps = {
  documentId: string
  enabled: boolean
}

export default function DocumentLogEntries({
  documentId,
  enabled,
}: DocumentLogEntriesProps) {
  const {
    logEntries,
    isPending: entriesIsLoading,
    fetchNextPage,
    hasNextPage, // It might be true even when no more entries are available since dynamo does pagination different, but once we get an empty page, it will be false
    isFetchingNextPage,
  } = useGetLogEntries({
    filters: {
      endpoint: '/v2/pd/documents',
      obj_id: documentId,
      limit: '30',
      reverse: 'true',
    },
    enabled,
  })

  return (
    <SectionAccordion title="Activity Log Entries">
      <List disablePadding>
        {entriesIsLoading && (
          <>
            <ListItem disablePadding>
              <ListItemText
                primary={<Skeleton animation="wave" width="85%" />}
                secondary={<Skeleton animation="wave" width="40%" />}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText
                primary={<Skeleton animation="wave" width="80%" />}
                secondary={<Skeleton animation="wave" width="40%" />}
              />
            </ListItem>
          </>
        )}
        {!entriesIsLoading &&
          (logEntries.length ? (
            logEntries.map((logEntry) => (
              <DocumentLogEntry key={logEntry.id} logEntry={logEntry} />
            ))
          ) : (
            <Typography color="text.secondary" variant="body2">
              None
            </Typography>
          ))}
      </List>

      {!entriesIsLoading && hasNextPage && (
        <Button
          onClick={() => fetchNextPage()}
          disabled={!hasNextPage || isFetchingNextPage}
          sx={{ mt: 1, ml: -0.5 }}
          variant="text"
        >
          {isFetchingNextPage ? 'Loading...' : 'Load More'}
        </Button>
      )}
    </SectionAccordion>
  )
}
